import { useWLoading } from '@pequity/shared/ui';
import { type Router } from 'vue-router';

export const displayWLoading = (router: Router) => {
  const { loadingShow, loadingHide } = useWLoading();

  router.beforeEach((_to, from) => {
    loadingHide('routeChange');

    if (from.name) {
      loadingShow({ id: 'routeChange' });
    }
  });

  router.afterEach(() => {
    loadingHide('routeChange');
  });
};
